import { FunctionComponent, SVGProps } from 'react'

export const IconCards: FunctionComponent<SVGProps<SVGSVGElement>> = ({
  id,
  ...props
}) => {
  const filter0 = `${id}-filter0`
  const filter1 = `${id}-filter1`
  return (
    <svg
      width="27"
      height="24"
      viewBox="0 0 27 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g opacity="0.6" filter={`url(#${filter0})`}>
        <path
          d="M8.66406 9.26156V6.0957C8.66406 5.54342 9.11178 5.0957 9.66406 5.0957H21.3724C21.5382 5.0957 21.6971 5.16155 21.8143 5.27876C21.9316 5.39597 21.9974 5.55494 21.9974 5.7207V14.9282C21.9974 15.4805 21.5497 15.9282 20.9974 15.9282H17.8307"
          stroke="#C8F252"
          strokeLinecap="square"
          shapeRendering="crispEdges"
        />
      </g>
      <g filter={`url(#${filter1})`}>
        <path
          d="M17.2109 9.26172H5.96094C5.61576 9.26172 5.33594 9.54154 5.33594 9.88672V18.6367C5.33594 18.9819 5.61576 19.2617 5.96094 19.2617H17.2109C17.5561 19.2617 17.8359 18.9819 17.8359 18.6367V9.88672C17.8359 9.54154 17.5561 9.26172 17.2109 9.26172Z"
          fill="url(#paint0_linear_2175_93183)"
          shapeRendering="crispEdges"
        />
        <path
          d="M17.2109 9.26172H5.96094C5.61576 9.26172 5.33594 9.54154 5.33594 9.88672V18.6367C5.33594 18.9819 5.61576 19.2617 5.96094 19.2617H17.2109C17.5561 19.2617 17.8359 18.9819 17.8359 18.6367V9.88672C17.8359 9.54154 17.5561 9.26172 17.2109 9.26172Z"
          stroke="#C8F252"
          strokeLinecap="square"
          shapeRendering="crispEdges"
        />
      </g>
      <defs>
        <filter
          id={filter0}
          x="4.16406"
          y="0.595703"
          width="22.3359"
          height="19.832"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2175_93183"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2175_93183"
            result="shape"
          />
        </filter>
        <filter
          id={filter1}
          x="0.835938"
          y="4.76172"
          width="21.5"
          height="19"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.784314 0 0 0 0 0.94902 0 0 0 0 0.321569 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_2175_93183"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_2175_93183"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_2175_93183"
          x1="11.5859"
          y1="9.26172"
          x2="11.5859"
          y2="17.9284"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#C8F252" stopOpacity="0" />
          <stop offset="1" stopColor="#C8F252" stopOpacity="0.6" />
        </linearGradient>
      </defs>
    </svg>
  )
}
